module.exports = __webpack_public_path__ + "img/financial.ef43afca.png";